module.exports = __webpack_public_path__ + "media/banners/crowdlog-80b07ecc.png";